var userAgent = require('../internals/engine-user-agent');

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/engine-is-ios.js
// module id = 235
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35